var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { isUrl } from "../../../urlUtils";
import { styled } from "../../../theme";
import { Button } from "../../../button";
import { Text } from "../../../text";
import { FlexColumn } from "../../../box";
import { SUPPORTED_MEDIA_TYPE_IMAGES } from "../../snapshot-control-field/utils";
import { FileInput } from "../file-input";
export var SnapshotControl = function (_a) {
    var name = _a.name, image = _a.image, disabled = _a.disabled, onChange = _a.onChange, transformUrl = _a.transformUrl, onClear = _a.onClear;
    return (React.createElement(FlexStart, null,
        React.createElement(ClickDelegate, { disabled: disabled },
            React.createElement(ImagePreviewContainer, { disabled: disabled, "data-test-id": name + "-preview" },
                image ? (React.createElement(PaddedImage, { src: isUrl(image) ? transformUrl(image) : image, alt: "Camera Preview" })) : (React.createElement(EmptyMessage, null,
                    React.createElement(CameraGlyph, { src: require("./assets/placeholder-camera.svg"), alt: "Camera Placeholder" }),
                    React.createElement(Text, { fontSize: 4 }, "Tap here to add photo"))),
                React.createElement(FileInput, { value: "", name: name, multiple: false, acceptedMediaTypes: SUPPORTED_MEDIA_TYPE_IMAGES, disabled: disabled, onChange: onChange }))),
        image && (React.createElement(ClearButton, { outline: true, color: "danger", size: "small", icon: "close", onClick: onClear, disabled: disabled }, "Remove"))));
};
SnapshotControl.defaultProps = {
    onChange: function () { },
    onClear: function () { },
    transformUrl: function (url) { return url; },
};
var ClickDelegate = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  max-width: 480px;\n  width: 100%;\n"], ["\n  cursor: ", ";\n  max-width: 480px;\n  width: 100%;\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "not-allowed" : "pointer");
});
var ClearButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 25px;\n\n  ", "\n\n  ", "\n"], ["\n  margin-left: 25px;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled &&
        "\n    color: " + theme.color.darkBlue60 + ";\n    border-color: " + theme.color.darkBlue60 + ";\n  ";
}, function (_a) {
    var hidden = _a.hidden;
    return hidden &&
        "\n    visibility: hidden;\n  ";
});
var FlexStart = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  margin-top: 0.625em;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  margin-top: 0.625em;\n"])));
var ImagePreviewContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  border-radius: 8px;\n  color: ", ";\n  border: 1px solid ", ";\n  background-color: rgba(43, 183, 217, 0.05);\n  ", "\n"], ["\n  display: flex;\n  border-radius: 8px;\n  color: ", ";\n  border: 1px solid ", ";\n  background-color: rgba(43, 183, 217, 0.05);\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled &&
        "\n    opacity: 0.6;\n    filter: saturate(25%);\n";
});
var EmptyMessage = styled(FlexColumn)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  width: 100%;\n  padding: 10px;\n\n  @media (min-width: ", "px) {\n    height: 300px;\n  }\n"], ["\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  width: 100%;\n  padding: 10px;\n\n  @media (min-width: ", "px) {\n    height: 300px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoint.lg;
});
var PaddedImage = styled.img(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 10px;\n  width: 100%;\n"], ["\n  padding: 10px;\n  width: 100%;\n"])));
var CameraGlyph = styled.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-bottom: 30px;\n"], ["\n  margin-bottom: 30px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
